import { CommonModule } from '@angular/common';
import { Component, EventEmitter, HostListener, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { PageHeaderComponent } from '../page-header/page-header.component';
import { VendorRow } from '../../pages/vendors/vendor-landing/vendor-landing.model';

type VendorDetailsTab = 'overview' | 'directors' | 'bank' | 'documents';

@Component({
  selector: 'app-vendor-details-modal',
  standalone: true,
  imports: [CommonModule, PageHeaderComponent],
  templateUrl: './vendor-details-modal.component.html',
  styleUrl: './vendor-details-modal.component.scss',
})
export class VendorDetailsModalComponent implements OnChanges {
  @Input({ required: true }) open = false;
  @Input() vendor: VendorRow | null = null;
  @Input() loading = false;
  @Output() close = new EventEmitter<void>();

  tab: VendorDetailsTab = 'overview';

  ngOnChanges(changes: SimpleChanges): void {
    const opened = changes['open']?.currentValue === true && changes['open']?.previousValue !== true;
    const vendorChanged = 'vendor' in changes && changes['vendor']?.currentValue !== changes['vendor']?.previousValue;
    if (opened || vendorChanged) this.tab = 'overview';
  }

  @HostListener('document:keydown.escape')
  onEscape(): void {
    if (!this.open) return;
    this.close.emit();
  }

  setTab(tab: VendorDetailsTab): void {
    this.tab = tab;
  }

  statusPillClass(status: string): string {
    const normalized = String(status ?? '').toUpperCase();
    if (normalized === 'APPROVED') return '!bg-green-100 !text-green-700';
    if (normalized === 'ACTIVE') return '!bg-green-100 !text-green-700';
    if (normalized === 'PENDING') return '!bg-amber-100 !text-amber-700';
    if (normalized === 'QUERIED') return '!bg-sky-100 !text-sky-700';
    if (normalized === 'REJECTED') return '!bg-red-100 !text-red-700';
    if (normalized === 'BLACKLISTED') return '!bg-red-100 !text-red-700';
    return 'bg-slate-100 text-slate-600';
  }

  maskBvn(value: string): string {
    const raw = String(value ?? '').trim();
    if (!raw) return 'N/A';
    const last4 = raw.slice(-4);
    return `******${last4}`;
  }

  formatDate(value: string): string {
    const raw = String(value ?? '').trim();
    if (!raw) return 'N/A';
    return raw;
  }

  trackByIndex(index: number): number {
    return index;
  }
}
